module.exports = __webpack_public_path__ + "img/1528699903.1a21630d.jpg";